import { __assign } from "tslib";
import React from 'react';
import MonoHtmlView from './CommissionHtml';
import MonoReactView from './Commission';
var CommissionMonoView = function (props) {
    if (props.isHtml) {
        return React.createElement(MonoHtmlView, __assign({}, props));
    }
    return React.createElement(MonoReactView, __assign({}, props));
};
CommissionMonoView.displayName = 'CommissionMonoView';
export default CommissionMonoView;
//# sourceMappingURL=index.js.map